module.exports = "/images/icon_08_02.svg?a68f94e98b66fa39c62b7fcf645f87ca";